// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__vuD3M","tagButton":"styles_tagButton__jN68Z","icon":"styles_icon__moaUj","label":"styles_label__9VE5x"};